module.exports = __webpack_public_path__ + "img/konishi.98500400.jpg";